import React from 'react';
import ReactDOM from 'react-dom/client';
import Main from './Main.js';
import "./styles/main.css";

/*ReactDOM.render(
    <Main />,
  document.getElementById("container")
);*/

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Main/>);